import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { DonateBar } from "@/components/DonateBar";
import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import About from "@/pages/About";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import GolfScramble from "@/pages/GolfScramble";

let lenis;

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenis = undefined;
    };
  }, []);

  return (
    <div className="App bg-paper text-ink font-sans">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main className="pb-20 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/about" element={<About />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/golf-scramble" element={<GolfScramble />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <DonateBar />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
